import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import { useArticle } from '../../hooks/useArticles'
import AirtableBlogSingle from '../../components/BlogDetails/AirtableBlogSingle.jsx'
import Footer from '../../components/footer/Footer';
import logo from '../../images/logo-2.svg';
import './BlogDetails.css';

const BlogDetails = (props) => {
    const { slug } = useParams()
    const { article } = useArticle(slug)

    return (
        <Fragment>
            <Navbar Logo={logo} hclass={'wpo-site-header wpo-site-header-s2'} />
            <div style={article?.featuredImage ? {
                '--blog-header-bg': `url(${article.featuredImage})`
            } : {}}>
                <PageTitle
                    pageTitle={article?.title || 'Article'}
                    pagesub={'Blog'}
                    customClass={article?.featuredImage ? 'blog-detail-header' : ''}
                />
            </div>
            <AirtableBlogSingle />
            <Footer hclass={"wpo-site-footer_s2"}/>
            <Scrollbar />
        </Fragment>
    )
};
export default BlogDetails;
